export const CheckCircle02 = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
   return (
      <svg
         width="25"
         height="25"
         viewBox="0 0 25 25"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <path
            d="M22.4666 10.6661C22.9233 12.9074 22.5978 15.2376 21.5445 17.2679C20.4911 19.2983 18.7735 20.9062 16.6781 21.8234C14.5828 22.7407 12.2363 22.9119 10.0299 22.3085C7.8236 21.7051 5.89082 20.3635 4.5539 18.5075C3.21699 16.6516 2.55675 14.3934 2.68329 12.1095C2.80983 9.82566 3.71551 7.65422 5.24928 5.9573C6.78305 4.26038 8.85221 3.14056 11.1117 2.78458C13.3712 2.4286 15.6844 2.85799 17.6656 4.00113"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
         <path
            d="M9.66602 11.6666L12.666 14.6666L22.666 4.66663"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
         />
      </svg>
   )
}
